import PropTypes from 'prop-types';

import { selectableItem } from '~/components/selectable-item';
import { TimeSlot } from '../time-slot';

import styles from '../TimeSlots.scss';

const SelectableTimeSlot = selectableItem(TimeSlot);

export const FormattedTimeSlotsList = ({
  slots,
  selectedTimeSlot,
  selectTimeSlot,
  formatSlots,
  areSlotsEqual,
}) => (
  <ul className={styles.Appointment_time__list} data-testid="TimeSlotSectionContent">
    {formatSlots(slots).map((slot) => (
      <li key={slot.from}>
        <SelectableTimeSlot
          propName="slot"
          slot={{
            eventId: slot.eventId,
            from: slot.from,
            to: slot.to,
          }}
          isChecked={areSlotsEqual(slot, selectedTimeSlot)}
          onChange={selectTimeSlot}
          title={slot.title}
        />
      </li>
    ))}
  </ul>
);

FormattedTimeSlotsList.propTypes = {
  slots: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  selectTimeSlot: PropTypes.func.isRequired,
  formatSlots: PropTypes.func.isRequired,
  areSlotsEqual: PropTypes.func.isRequired,
  selectedTimeSlot: PropTypes.shape({
    from: PropTypes.number.isRequired,
    to: PropTypes.number,
  }).isRequired,
};
